import create from 'zustand/vanilla';

const focusFilter = create(() => ({
  /**
   * Focus filter object
   */
  filters: [],

  /**
   * Update focusFilter object
   * @param {array} selectedFilters Selected filters
   * @return {void}
   */
  updateFilters: (selectedFilters) => {
    const { setState } = focusFilter;

    setState({ filters: selectedFilters });
  }
}));

export default focusFilter;
